import { ChartRegistry } from '@/types/chart-registry';
import { SkyCompetitiveOverviewEcharts } from '@/components/dune-graph-2';
import { YieldChart } from '@/components/yield-graph';
import { MeaningfulWallets } from '@/components/meaningful-wallets';
import { DaiOverHoldingGroups, LockstakeSKYonSKYOverHoldingGroups, SdaiOverHoldingGroups, SkyOverHoldingGroups, SpkOverHoldingGroups, SpusdcOverHoldingGroups, SpusdtOverHoldingGroups, StusdsOverHoldingGroups, SusdcOverHoldingGroups, SusdeOverHoldingGroups, SusdsOverHoldingGroups, SyUSDCOverHoldingGroups, SyUSDTOverHoldingGroups, UsdsOverHoldingGroups } from '@/components/sky-over-holding-groups';
import { GrossCashflow, GrossCashflowOut } from '@/components/gross-cashflow';
import { SkyTokenRewardsBalance, SpkTokenRewardsBalance } from '@/components/token-rewards';
import { SkyTokenOverview } from '@/components/sky-token-overview';
import { LockstakeSkyRestaking, LockstakeSkyYield } from '@/components/sky-on-sky-restaking';
import { InactiveMKR } from '@/components/inactive-mkr';
import { MorphoSTUSDS } from '@/components/morpho-stusds';
import MorphoV2Stables from '@/components/morpho-v2-stables';
import { SffBalancesChart } from '@/components/sff-balances-chart';
import { CoreCouncilTransactions, SffTransactions, SparkTransactions } from '@/components/sff-transactions';
import { SkyTokenHoldingsByTag, spUsdcTokenHoldingsByTag, spUsdtTokenHoldingsByTag, sUsdeTokenHoldingsByTag, sUsdsTokenHoldingsByTag, UsdeTokenHoldingsByTag, UsdsTokenHoldingsByTag } from '@/components/token-holdings-by-tag';

export const chartRegistry: ChartRegistry = {
  charts: [
    {
      id: 1,
      name: 'Market Overview',
      description: 'Total market size across yield competitors',
      type: 'area',
      queryId: 6680585,
      component: SkyCompetitiveOverviewEcharts,
      defaultVisible: true,
      category: 'Market Analysis'
    },
    // {
    //   id: 2,
    //   name: 'Market Share Percentage',
    //   description: 'Percentage market share by competitor',
    //   type: 'area',
    //   queryId: 6320808,
    //   component: CompetitiveOverviewPct,
    //   defaultVisible: true,
    //   category: 'Market Analysis'
    // },
    {
      id: 3,
      name: 'Yield Trends',
      description: 'Yield rates over time across protocols',
      type: 'line',
      queryId: 6711808,
      component: YieldChart,
      defaultVisible: true,
      category: 'Market Analysis'
    },
    {
      id: 4,
      name: 'USDS Total Supply',
      description: 'Overview of USDS supply over time broken down by product',
      type: 'area',
      queryId: 101,
      component: SkyTokenOverview,
      defaultVisible: true,
      category: 'Sky Ecosystem',
      virtual: true
    },
    {
      id: 5,
      name: 'Meaningful Wallets',
      description: 'Wallets holding 10+ tokens by month',
      type: 'bar',
      queryId: 6449096,
      component: MeaningfulWallets,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 6,
      name: 'Gross Cashflow',
      description: 'Gross infows to Sky\'s Capital Buffer',
      type: 'bar',
      queryId: 6314629,
      component: GrossCashflow,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 7,
      name: 'Cash Out',
      description: 'Outflows from Sky\'s Capital Buffer',
      type: 'bar',
      queryId: 6323958,
      component: GrossCashflowOut,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 8,
      name: 'Sky token ownership',
      description: 'Wallet groups holding SKY',
      type: 'area',
      queryId: 6127312,
      component: SkyOverHoldingGroups,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
        id: 9,
        name: 'USDS token ownership',
        description: 'Wallet groups holding USDS',
        type: 'area',
        queryId: 4833782,
        component: UsdsOverHoldingGroups,
        defaultVisible: true,
        category: 'Sky Ecosystem'
    },
    {
        id: 10,
        name: 'sUSDS token ownership',
        description: 'Wallet groups holding sUSDS',
        type: 'area',
        queryId: 4833785,
        component: SusdsOverHoldingGroups,
        defaultVisible: true,
        category: 'Sky Ecosystem'
    },
    {
        id: 11,
        name: 'stUSDS token ownership',
        description: 'Wallet groups holding sUSDS',
        type: 'area',
        queryId: 5959722,
        component: StusdsOverHoldingGroups,
        defaultVisible: true,
        category: 'Sky Ecosystem'
    },
    // {
    //     id: 12,
    //     name: 'Spark sUSDC token ownership',
    //     description: 'Wallet groups holding sUSDC',
    //     type: 'area',
    //     queryId: 5190070,
    //     component: SusdcOverHoldingGroups,
    //     defaultVisible: true,
    //     category: 'Spark Finance'
    // },
    {
        id: 13,
        name: 'DAI token ownership',
        description: 'Wallet groups holding DAI',
        type: 'area',
        queryId: 5693648,
        component: DaiOverHoldingGroups,
        defaultVisible: true,
        category: 'Sky Ecosystem'
    },
    // {
    //   id: 14,
    //   name: 'sDAI token ownership',
    //   description: 'Wallet groups holding sDAI',
    //   type: 'area',
    //   queryId: 4538275,
    //   component: SdaiOverHoldingGroups,
    //   defaultVisible: true,
    //   category: 'Sky Ecosystem'
    // },
    {
      id: 15,
      name: 'SKY Token Rewards Balances',
      description: 'Wallet groups depositing USDS into Sky TR',
      type: 'area',
      queryId: 5053707,
      component: SkyTokenRewardsBalance,
      defaultVisible: false,
      category: 'Sky Ecosystem'
    },
    {
      id: 16,
      name: 'SPK Token Rewards Balances',
      description: 'Wallet groups depositing USDS into Spark TR',
      type: 'area',
      queryId: 5376479,
      component: SpkTokenRewardsBalance,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 17,
      name: 'Lockstake SKY/SKY Restaking Analysis',
      description: 'Lockstake SKY/SKY Farm behaviours',
      type: 'mixed',
      queryId: 6138270,
      component: LockstakeSkyRestaking,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 18,
      name: 'Spark spUSDC token ownership',
      description: 'Wallet groups holding spUSDC',
      type: 'area',
      queryId: 6015027,
      component: SpusdcOverHoldingGroups,
      defaultVisible: true,
      category: 'Spark Finance'
    },
    {
      id: 19,
      name: 'Spark spUSDT token ownership',
      description: 'Wallet groups holding spUSDT',
      type: 'area',
      queryId: 6015033,
      component: SpusdtOverHoldingGroups,
      defaultVisible: true,
      category: 'Spark Finance'
    },
    {
      id: 20,
      name: 'SPK token ownership',
      description: 'Wallet groups holding SPK',
      type: 'area',
      queryId: 6127580,
      component: SpkOverHoldingGroups,
      defaultVisible: true,
      category: 'Spark Finance'
    },
    {
      id: 21,
      name: 'Inactive MKR',
      description: 'MKR sitting in non-transacting wallets',
      type: 'area',
      queryId: 6543887,
      component: InactiveMKR,
      defaultVisible: false,
      category: 'Sky Ecosystem'
    },
    {
      id: 22,
      name: 'Lockstake SKY/SKY Depositors',
      description: 'SKY farm deposits over holding groups',
      type: 'area',
      queryId: 6158493,
      component: LockstakeSKYonSKYOverHoldingGroups,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 23,
      name: 'Morpho stUSDS v2 Vaults',
      description: 'Sky\'s Morpho Vaults that provide liquidity against stUSDS',
      type: 'area',
      queryId: 6777432,
      component: MorphoSTUSDS,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 24,
      name: 'Morpho v2 Vaults Stable Deposits',
      description: 'Major Stablecoin deposits in V2 Vaults including USDC, USDT, PYUSD, USDS and RLUSD',
      type: 'area',
      queryId: 6819416,
      component: MorphoV2Stables,
      defaultVisible: true,
      category: 'Morpho'
    },
    {
      id: 25,
      name: 'SKY/SKY Yield',
      description: 'Estimated APY paid out by Sky on its Lockstake Yield engine.',
      type: 'area',
      queryId: 6854509,
      component: LockstakeSkyYield,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 26,
      name: 'Syrup USDC over holding groups',
      description: 'Maple\'s Syrup USDC yield offering balances',
      type: 'area',
      queryId: 5292252,
      component: SyUSDCOverHoldingGroups,
      defaultVisible: true,
      category: 'Maple'
    },
    {
      id: 27,
      name: 'Ethena sUSDe over holding groups',
      description: 'Ethena\'s Staked USDe yield offering balances',
      type: 'area',
      queryId: 4511356,
      component: SusdeOverHoldingGroups,
      defaultVisible: true,
      category: 'Ethena'
    },
    {
      id: 28,
      name: 'Sky Frontier Foundation Balances',
      description: 'SFF tracking',
      type: 'area',
      queryId: 6808860,
      component: SffBalancesChart,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 29,
      name: 'Syrup USDT over holding groups',
      description: 'Maple\'s Syrup USDT yield offering balances',
      type: 'area',
      queryId: 5292256,
      component: SyUSDTOverHoldingGroups,
      defaultVisible: true,
      category: 'Maple'
    },
    // {
    //   id: 65537,
    //   name: 'Sky Frontier Foundation Transfers',
    //   description: 'SFF',
    //   queryId: 7444703,
    //   type: 'sankey',
    //   component: SffTransactions,
    //   defaultVisible: false,
    //   category: 'Sky Ecosystem'
    // },
    {
      id: 65538,
      name: 'Core Council Transfers',
      description: 'Core Council Transfers, aggregated by month',
      type: 'sankey',
      queryId: 7507144,
      component: CoreCouncilTransactions,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },
    {
      id: 65539,
      name: 'Spark Agent Transfers',
      description: 'Spark Transfers, aggregated by month',
      type: 'sankey',
      queryId: 7646158,
      component: SparkTransactions,
      defaultVisible: true,
      category: 'Sky Ecosystem'
    },

    {
      id: 128000,
      name: 'SKY over tags',
      description: 'SKY over tags',
      type: 'area',
      virtual: true,
      component: SkyTokenHoldingsByTag,
      defaultVisible: true,
      category: 'Sky Ecosystem - Collector'
    },
    {
      id: 128001,
      name: 'USDS over tags',
      description: 'USDS over tags',
      type: 'area',
      virtual: true,
      component: UsdsTokenHoldingsByTag,
      defaultVisible: true,
      category: 'Sky Ecosystem - Collector'
    },
    {
      id: 128002,
      name: 'sUSDS over tags',
      description: 'sUSDS over tags',
      type: 'area',
      virtual: true,
      component: sUsdsTokenHoldingsByTag,
      defaultVisible: true,
      category: 'Sky Ecosystem - Collector'
    },
    {
      id: 128003,
      name: 'USDE over tags',
      description: 'USDE over tags',
      type: 'area',
      virtual: true,
      component: UsdeTokenHoldingsByTag,
      defaultVisible: true,
      category: 'Sky Ecosystem - Collector'
    },
    {
      id: 128004,
      name: 'sUSDE over tags',
      description: 'sUSDE over tags',
      type: 'area',
      virtual: true,
      component: sUsdeTokenHoldingsByTag,
      defaultVisible: true,
      category: 'Sky Ecosystem - Collector'
    },
    {
      id: 128005,
      name: 'spUSDC over tags',
      description: 'spUSDC over tags',
      type: 'area',
      virtual: true,
      component: spUsdcTokenHoldingsByTag,
      defaultVisible: true,
      category: 'Sky Ecosystem - Collector'
    },
    {
      id: 128006,
      name: 'spUSDT over tags',
      description: 'spUSDT over tags',
      type: 'area',
      virtual: true,
      component: spUsdtTokenHoldingsByTag,
      defaultVisible: true,
      category: 'Sky Ecosystem - Collector'
    },
    
  ]
};
